import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput } from '@/_components';

import { type OrganizationTypeFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<OrganizationTypeFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6"
            label="Organization Type (required)"
            {...field}
            disabled={!isEditable}
            autoFocus={autoFocus}
          />
        )}
      />

      <FormField
        control={form.control}
        name="plural"
        render={({ field }) => (
          <FormInput formItemClassName="col-span-12 sm:col-span-6" label="Plural" {...field} disabled={!isEditable} />
        )}
      />
    </>
  );
}
